<template>
  <div class="justify-content-center text-center text-color-light home-carousel" :style="{ backgroundColor: backgroundColor }">
    <div class="carousel-slide" style="z-index: 1">
      <div class="row">
        <!-- ################ Transición Títulos ################ -->
        <transition name="fade" mode="out-in">
          <h1 :key="activeIndex" class="text-color-light text-title orbitron-font">
            {{ titles[activeIndex] }}
          </h1>
        </transition>
        <!-- ################ Transición Contenido ################ -->
        <transition name="fade" mode="out-in">
          <!-- Pantallas Grandes -->
          <p v-if="!isMobileCarousel" v-html="texts[activeIndex]" class="fs-3 text-color-light oswald-font mt-4" style="padding-left: 15%; padding-right: 15%"></p>
          <!-- Pantallas Pequeñas -->
          <p v-else v-html="textsMobile[activeIndex]" class="fs-3 text-color-light oswald-font mt-4" style="padding-left: 5%; padding-right: 5%"></p>
        </transition>
      </div>
    </div>
    <!-- ################ Progress Bar ################ -->
    <!-- Pantallas Grandes -->
    <div v-if="!isMobileCarousel" class="progress-controls-container mx-0">
      <div class="progress-container">
        <div
          class="carousel-progress-bar"
          :style="{
            width: `${((totalTime - totalRemainingTime) / totalTime) * 100}%`,
          }"
        ></div>
        <div class="carousel-icons d-flex justify-content-between">
          <div v-for="(image, index) in imagesURL" class="thumbnail-container position-relative" :key="index">
            <img :src="image" alt="Miniatura de la diapositiva." class="thumbnail img-fluid" :class="{ active: activeIndex === index }" @click="goToSlide(index)" />
            <div class="thumbnail-text text-color-light position-absolute top-50 start-50 translate-middle">
              {{ titles[index] }}
            </div>
          </div>
        </div>
      </div>
      <div class="controls">
        <i @click="pauseCarousel" :class="isPaused ? 'fa-regular fa-circle-play' : 'fa-regular fa-circle-pause'"></i>
      </div>
    </div>
    <!-- Pantallas Pequeñas -->
    <div v-else class="carousel-controls">
      <i @click="pauseCarousel" :class="isPaused ? 'fa-regular fa-circle-play' : 'fa-regular fa-circle-pause'"></i>
      <div v-for="(image, index) in imagesURL" class="dot" :key="index" :class="{ active: activeIndex === index }" @click="goToSlide(index)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    texts: {
      type: Array,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'var(--Black)',
    },
    textsMobile: {
      type: Array,
      required: true,
    },
    titles: {
      type: Array,
      required: true,
    },
    imagesURL: {
      type: Array,
      required: true,
    },
    totalSlides: {
      type: Number,
      required: true,
    },
    slideTime: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    totalTime() {
      return this.totalSlides * this.slideTime;
    },
  },
  data() {
    return {
      totalRemainingTime: 0,
      activeIndex: 0,
      isMobileCarousel: false,
      isPaused: false,
      interval: null,
    };
  },
  methods: {
    handleResize(variable, width) {
      this[variable] = window.innerWidth <= width;
    },
    startCarousel() {
      this.interval = setInterval(() => {
        if (!this.isPaused) {
          this.totalRemainingTime--;
          if (this.totalRemainingTime % this.slideTime === 0 && this.totalRemainingTime > 0) {
            this.activeIndex = (this.activeIndex + 1) % this.totalSlides;
          }
          if (this.totalRemainingTime <= 0) {
            this.totalRemainingTime = this.totalTime;
            this.activeIndex = 0;
          }
        }
      }, 1000);
    },
    pauseCarousel() {
      this.isPaused = !this.isPaused;
    },
    goToSlide(index) {
      this.activeIndex = index;
      this.totalRemainingTime = this.totalTime - index * this.slideTime;
    },
  },
  mounted() {
    // ------------ Responsividad ------------
    this.handleResize('isMobileCarousel', 1300);
    window.addEventListener('resize', () => this.handleResize('isMobileCarousel', 1300));
    // ------------ Responsividad ------------
    this.totalRemainingTime = this.totalTime;
    this.startCarousel();
  },
  beforeUnmount() {
    // ------------ Responsividad ------------
    window.removeEventListener('resize', this.handleResize);
    // ------------ Responsividad ------------
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="scss">
.home-carousel {
  // background-image: url('/videos/Carrusel.gif');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: overlay;
  border-radius: 10px;
  width: 100%;
  margin: auto;
  padding: 1rem;
  z-index: 1;
}

.carousel-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50dvh;
  height: auto;
  transition: opacity 1s ease;
}

.progress-controls-container {
  display: flex;
  align-items: center;
  margin-top: 1dvh;
  padding-bottom: 5dvh;
}

.progress-container {
  flex: 1;
  position: relative;
  height: 1dvh;
  background-color: var(--Dark-Sky);
  border-radius: 15px;
  margin-left: 10dvh;
  margin-right: 5dvh;
  overflow: visible;
}

.carousel-progress-bar {
  height: 100%;
  background-color: var(--Yellow);
  transition: width 1s linear;
}

.carousel-icons {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  padding: 0 10px;
}

.thumbnail-container {
  position: relative;
  display: inline-block;
  // background-color: var(--Sky);
  cursor: pointer;
  transition: 0.3s ease;

  .thumbnail {
    width: 8dvw;
    height: 6dvh;
    object-fit: cover;
    border-radius: 15%;
    cursor: pointer;
    transition: transform 0.3s, border 0.3s;
    border: 2px solid var(--Dark-Sky);
    background-color: var(--Dark-Sky);
    background-blend-mode: overlay;

    &.active {
      border-color: var(--Yellow);
      transform: scale(1.1);
    }

    &:hover {
      border-color: var(--Yellow);
    }
  }

  .thumbnail-text {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: var(--Light);
    font-size: 12px;
    border-radius: 3px;
    pointer-events: none;
  }
}

.controls i {
  font-size: 2rem;
  cursor: pointer;
  color: var(--Yellow);
  margin-right: 10dvh;
  gap: 10px;
}

@media (max-width: 1200px) {
  .home-carousel {
    padding: 1rem;
    position: relative;
    min-height: 70dvh;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .carousel-controls {
    display: flex;
    align-items: center;
    margin-bottom: 1dvh;
    gap: 5dvh !important;
    position: absolute;
    bottom: 5%;
    padding: 0 5rem;

    .dots-container {
      display: flex;
      gap: 0.25rem !important;
      position: absolute;
      bottom: 5%;
    }

    .dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: var(--Dark-Sky);
      cursor: pointer;
      transition: background-color 0.3s;

      &.active {
        background-color: var(--Yellow);
      }
    }

    i {
      font-size: 2rem;
      cursor: pointer;
      color: var(--Yellow);
      margin-right: 1dvh;
      gap: 10px;
    }
  }
}
</style>
